import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import countriesAndTimezone from 'countries-and-timezones';
import subMonths from 'date-fns/sub_months';
import {globalfunc} from '../globalfunc.js';
import axios from 'axios';
import { getCompany,getTeamByCompany,getUserAll } from './core/cacheService'
export default {
    namespaced: true,
    state: {
        billingData:[],
        activeMember:[],
        subscription: 0,
        reward_charges: 0,
        reward_credit_balance: 0,
        reward_pending: 0,
        rewards: {},
        rewardsCompany: {},
        MonthOfYearOpt: [],
        selectMonthOfYear: '',
        loadingDatableTable: true,
        startData: '2021-01-01',
        companySymbol: 'THB',
        countryInCompany:{},
        countryMember:{},
        allSymbol: {
            ['THB']: '฿',
        },
        topupCredit: 0,
        billingSummary: [],
        billingPending: {},
        htmlExport: '',
    },
    mutations: {
        setBillingData(state:any, result:any) {
            state.billingData = result
        },
        setRewards(state:any, result:any) {
            state.rewards = result
        },
        setRewardsCompany(state:any, result:any) {
            state.rewardsCompany = result
        },
        setActiveMember(state:any, result:any) {
            state.activeMember = result
        },
        setSubscription(state:any, result:any) {
            state.subscription = result
        },
        setRewardCharge(state:any, result:any) {
            state.reward_charges = result
        },
        setCreditBalance(state:any, result:any) {
            state.reward_credit_balance = result
        },
        setTopupCredit(state:any, result:any) {
            state.topupCredit = result
        },
        setRewardPending(state:any, result:any) {
            state.reward_pending = result
        },
        setMonthOfYearOpt(state:any, result:any) {
            state.MonthOfYearOpt = result
        },
        setSelectMonthOfYear(state:any, result:any) {
            state.selectMonthOfYear = result
        },
        setLoading(state:any, result:any) {
            state.loadingDatableTable = result
        },
        setCompanySymbol(state:any, result:any) {
            state.companySymbol = result
        },
        setAllSymbol(state:any, result:any) {
            state.allSymbol = result
          },
        setCountryInCompany(state:any, result:any) {
            state.countryInCompany = result
        },
        setCountryMember(state:any, result:any){
            state.countryMember = result
        },
        setBillingSummary(state:any, result:any){
            state.billingSummary = result
        },
        setBillingPending(state:any, result:any){
            state.billingPending = result
        },
        setHtmlExport(state:any, result:any) {
            state.htmlExport = result
        },
    },
    actions: {
        async getMasterRewards({commit,dispatch,state}:any, user:any){
            const {rewards, rewardsCompany} = state
            const rewardsTemp = {};
            if ( Object.keys(rewards).length === 0 )  {
                firebase.database().ref('rewards').once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        let _data = childSnapshot.val();
                        _data.key = childSnapshot.key;
                        rewardsTemp[_data.key] = _data;
                    });
                    commit('setRewards', rewardsTemp)
                });
            }
            const rewardsTemp2 = {};
            if ( Object.keys(rewardsCompany).length === 0 )  {
                firebase.database().ref(`rewards_company/${user.company}`).once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        let _datas = childSnapshot.val();
                        _datas.key = childSnapshot.key;
                        rewardsTemp2[_datas.key] = _datas;
                    });
                    commit('setRewardsCompany', rewardsTemp2)
                });
            }
        },
        async getMonthOfYearOpt({commit,dispatch,state}:any, user:any){
            const {MonthOfYearOpt} = state
            let MonthTemp:Array<any> = []
            let MonthOpt:Array<any> = []
            let billing_pending:any = []
            const cmpOpt = await getCompany(user.company)//(await firebase.database().ref(`company/${user.company}`).once('value')).val()
            if(cmpOpt !== undefined && cmpOpt.wallet !== undefined && cmpOpt.wallet_multiple !== undefined && cmpOpt.wallet_multiple == true){
                _.forEach(cmpOpt.wallet, (item, key) => {
                    if(key && billing_pending[key] == undefined){
                        billing_pending[key] = []
                    }
                    if(billing_pending[key]['reward_pending'] == undefined){
                        billing_pending[key]['reward_pending'] = 0
                    }
                });
            }
            let currency = 'THB'
            let companySymbol = 'THB'
            let allSymbolByKey = (await firebase.database().ref('currency').once('value')).val()
            let allSymbol: Array<any> = [];
            const billingInfo = (await firebase.database().ref(`billing_info/${user.company}`).once('value')).val()
            if(cmpOpt.billing_currency){
                currency = cmpOpt.billing_currency
            }
            if(Object.keys(allSymbolByKey).length > 0){
                let currencyData:any = _.find(allSymbolByKey, { currency: currency });
                companySymbol = (currencyData && currencyData.currency)?currencyData.currency:'THB'
                _.forEach(allSymbolByKey, (item, key) => {
                  allSymbol[item.currency] = (item && item.symbol)?item.symbol:'฿'
                });
                commit('setAllSymbol', allSymbol)
            }
            commit('setCompanySymbol', companySymbol)

            let reward_pending = 0
            const dateNow = new Date()
            const checkDate = `${format(dateNow,'YYYY-MM')}-${(billingInfo && billingInfo.billing_day !== undefined) ? `${billingInfo.billing_day}` : '20'}`
            let selectMonth = ''
            if(Object.keys(MonthOfYearOpt).length === 0){
                //FIX For current month//
                let thismonth:Array<any> = []
                if(dateNow > new Date(checkDate)){
                    let setDate = dateNow
                    setDate.setMonth(setDate.getMonth() + 1);
                    thismonth['label'] = format(setDate, 'MMMM YYYY')
                    thismonth['value'] = format(setDate, 'YYYY-MM')
                }else{
                    thismonth['label'] = format(dateNow, 'MMMM YYYY')
                    thismonth['value'] = format(dateNow, 'YYYY-MM')
                }
                
                MonthTemp[thismonth['value']] = thismonth
                MonthOpt.push(thismonth)
              
                //////////////////////////
                const redeemRewardsData:Array<any> = []
                var promise1 = new Promise(function(resolve, reject) {
                    const currency_rate:Array<any> = []
                    const currency_rate_Data:Array<any> = []
                    // firebase.database().ref('redeem_rewards').orderByChild("company").equalTo(user.company).once('value', (snapshot) => {
                    //     snapshot.forEach((childSnapshot) => {
                    //         let _data = childSnapshot.val();
                    firebase.firestore().collection(`redeem_rewards`).where('company','==',user.company).get()
                    .then(async function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            let _data = doc.data()
                            let option:Array<any> = []
                            option['label'] = format(_data.updated, 'MMMM YYYY')
                            option['value'] = format(_data.updated, 'YYYY-MM')
                            if(MonthTemp[option['value']] == undefined){
                                MonthTemp[option['value']] = option
                                MonthOpt.push(option)
                            }
                            // if(_data.updated >= state.startData+' 00:00:00' && doc.id == _data.redeem_rewards_id){
                            if(_data.updated >= state.startData+' 00:00:00' && (_data.type !== 'gift' || (_data.type == 'gift' && doc.id.slice(-2) !== '-2'))){ //Detect Gift type rewards will have 2 records.
                                if(_data.status !== 'Y' && _data.status !== 'X' && _data.status !== 'C'){
                                    if(state.rewards[_data.reward] !== undefined){
                                        _data.reward_currency = state.rewards[_data.reward].reward_currency
                                    } else if(state.rewardsCompany[_data.reward]){
                                        _data.reward_currency = state.rewardsCompany[_data.reward].reward_currency
                                    }else{
                                        _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
                                    }
                                    /* For reward has been deleted */
                                    if(_data.reward_currency == undefined){
                                        _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
                                    }
                                    /* End For reward has been deleted */
                                    if(_data['exchangerate'] && _data['exchangerate'].target_code){
                                        _data.reward_currency = _data['exchangerate'].target_code
                                    }
                                    if(cmpOpt && cmpOpt.billing_currency !== _data.reward_currency && (cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false) && _data['exchangerate'] == undefined){
                                        if(currency_rate[_data.reward_currency+'_to_'+cmpOpt.billing_currency] == undefined){
                                            currency_rate[_data.reward_currency+'_to_'+cmpOpt.billing_currency] = true
                                        }
                                    }
                                    redeemRewardsData.push(_data) 
                                }
                            }
                        });
                        if(currency_rate && Object.keys(currency_rate).length > 0){
                            for(const i in currency_rate){
                                let currArr = i.split("_to_");
                                let from = currArr[0];
                                let to = currArr[1];
                                var axios = require('axios');
                                const config = {
                                    method: 'get',
                                    url: `https://api-node.happily.ai/wogi/exchagerate/${from}/${to}/${1}`,
                                    headers: {
                                    'Content-Type': 'application/json'
                                    },
                                    data : ''
                                };
                                await axios(config)
                                .then(response => {
                                    if(response.data.result === 'success'){
                                        let price = response.data.conversion_result;
                                        currency_rate_Data[from+'_to_'+to] = price
                                    }
                                })
                            }
                        }
                        resolve(currency_rate_Data);
                        
                    });
                });
                
                Promise.all([promise1]).then((values)=> {
                    const currencyRateOtp:any = values[0]
                    _.forEach(redeemRewardsData, (item:any) => {
                        let _data = item
                        
                        let priceFee:any
                        let calfee:any
                        
                        if(state.rewards[_data.reward] !== undefined){
                            _data.newtype = state.rewards[_data.reward].newtype
                        } else {
                            if(state.rewardsCompany[_data.reward]){
                                _data.newtype = state.rewardsCompany[_data.reward].newtype
                            }
                        }

                        if(_data.reward_currency && billing_pending[_data.reward_currency] == undefined){
                            billing_pending[_data.reward_currency] = []
                        }
                        if(billing_pending[_data.reward_currency]['reward_pending'] == undefined){
                            billing_pending[_data.reward_currency]['reward_pending'] = 0
                        }
                        if(_data.price !== undefined && Number(_data.price) !== 0){
                            _data.price = Number(_data.price)
                        }else{
                            _data.price = 0
                        }
                        if(cmpOpt && cmpOpt.billing_currency !== _data.reward_currency && (cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false) && _data['exchangerate'] == undefined){
                            if(currencyRateOtp[_data.reward_currency+'_to_'+cmpOpt.billing_currency] !== undefined){
                                _data.price = Number(_data.price) * Number(currencyRateOtp[_data.reward_currency+'_to_'+cmpOpt.billing_currency])
                            }
                        }
                        _data.firstprice = Number(_data.price)
                        if(_data.newtype && _data.newtype == 'Item'){ // Merchandise
                            if((_data.feerate !== undefined && Number(_data.feerate) !== 0) || (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
                                if(_data.feerate && _data.feerate_happily){
                                    if(_data.feerate_happily > _data.feerate){
                                        _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
                                    }else{
                                        _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
                                    }
                                }else if(_data.feerate){
                                    _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
                                }else if(_data.feerate_happily){
                                    _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
                                }
                            }
                            if(_data.taxrate && _data.taxrate > 0){
                                _data.price = Number(_data.price) + ((Number(_data.price) * Number(_data.taxrate))/100)
                            }
                            billing_pending[_data.reward_currency]['reward_pending'] += Number(_data.firstprice)
                            reward_pending += Number(_data.firstprice)
                        }else{
                            if((_data.feerate !== undefined && Number(_data.feerate) !== 0) && (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
                                if(_data.feerate_happily > _data.feerate){
                                    calfee =  (Number(_data.price) * _data.feerate_happily) / 100
                                }else{
                                    calfee =  (Number(_data.price) * _data.feerate) / 100
                                }
                                if(_data.taxrate && _data.taxrate > 0){
                                    let caltax = (calfee * Number(_data.taxrate))/100
                                    priceFee = Number(_data.price) + Number(calfee) + Number(caltax)
                                }else{
                                    priceFee = Number(_data.price) + Number(calfee)
                                }
                                billing_pending[_data.reward_currency]['reward_pending'] += Number(_data.firstprice)
                                reward_pending += Number(_data.firstprice)
                            } else if(_data.feerate !== undefined && Number(_data.feerate) !== 0){
                                calfee =  (Number(_data.price) * _data.feerate) / 100
                                if(_data.taxrate && _data.taxrate > 0){
                                    let caltax = (calfee * Number(_data.taxrate))/100
                                    priceFee = Number(_data.price) + Number(calfee) + Number(caltax)
                                }else{
                                    priceFee = Number(_data.price) + Number(calfee)
                                }
                                billing_pending[_data.reward_currency]['reward_pending'] += Number(_data.firstprice)
                                reward_pending += Number(_data.firstprice)
                            } else if(_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0){
                                calfee =  (Number(_data.price) * _data.feerate_happily) / 100
                                if(_data.taxrate && _data.taxrate > 0){
                                    let caltax = (calfee * Number(_data.taxrate))/100
                                    priceFee = Number(_data.price) + Number(calfee) + Number(caltax)
                                }else{
                                    priceFee = Number(_data.price) + Number(calfee)
                                }
                                billing_pending[_data.reward_currency]['reward_pending'] += Number(_data.firstprice)
                                reward_pending += Number(_data.firstprice)
                            } else if (_data.price !== undefined){
                                billing_pending[_data.reward_currency]['reward_pending'] += Number(_data.firstprice)
                                reward_pending += Number(_data.firstprice)
                            }else{
                                billing_pending[_data.reward_currency]['reward_pending'] += 0
                                reward_pending += 0
                            }
                        }
                    });
                    firebase.firestore().collection(`instant_reward_credit_trans`).where('company','==',user.company).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            let _data = doc.data();
                            let option:Array<any> = []
                            option['label'] = format(_data.transaction_date, 'MMMM YYYY')
                            option['value'] = format(_data.transaction_date, 'YYYY-MM')
                            if(MonthTemp[option['value']] == undefined){
                                MonthTemp[option['value']] = option
                                MonthOpt.push(option)
                            }
                        });
                        MonthOpt = _.sortBy(MonthOpt, [function(o:any) { return o.value; }]).reverse()
                        selectMonth = MonthOpt[0]
                        commit('setMonthOfYearOpt', MonthOpt)
                        commit('setSelectMonthOfYear', selectMonth)
                        if(cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false){
                            billing_pending = []
                            if(cmpOpt.billing_currency && billing_pending[cmpOpt.billing_currency] == undefined){
                                billing_pending[cmpOpt.billing_currency] = []
                            }
                            if(billing_pending[cmpOpt.billing_currency]['reward_pending'] == undefined){
                                billing_pending[cmpOpt.billing_currency]['reward_pending'] = 0
                            }
                            billing_pending[cmpOpt.billing_currency]['reward_pending'] = reward_pending
                        }
                        commit('setBillingPending', billing_pending)
                        commit('setRewardPending', reward_pending)
                    });
                });
                // firebase.firestore().collection(`active_users`).where('company','==',user.company).get()
                // .then(function (querySnapshot) {
                //     querySnapshot.forEach(function (doc) {
                //         let _data1 = doc.data();
                //         if(_data1.date >= state.startData){
                //             if(_data1.status == undefined || _data1.status !== 'Y'){
                //                 let discount = (_data1.discount != undefined)?_data1.discount: cmpOpt.discount * 1;
                //                 _data1.price = (cmpOpt !== undefined ) ? cmpOpt.rate : 0;
                //                 _data1.totalnumber = (discount > 0)?(_data1.price * _data1.active_users) * (1 - (discount / 100)):_data1.price * _data1.active_users;
                //                 _data1.total = _data1.totalnumber
                //                 // reward_pending += _data1.total
                //             }
                //         }
                //     });
                //     firebase.database().ref('redeem_rewards').orderByChild("company").equalTo(user.company).once('value', (snapshot) => {
                //         snapshot.forEach((childSnapshot) => {
                //             let _data = childSnapshot.val();
                //             let option:Array<any> = []
                //             option['label'] = format(_data.updated, 'MMMM YYYY')
                //             option['value'] = format(_data.updated, 'YYYY-MM')
                //             if(MonthTemp[option['value']] == undefined){
                //                 MonthTemp[option['value']] = option
                //                 MonthOpt.push(option)
                //             }
                //             if(_data.updated >= state.startData+' 00:00:00'){
                //                 if(_data.status !== 'Y' && _data.status !== 'X' && _data.status !== 'C'){
                //                     let priceFee:any
                //                     let calfee:any
                                   
                //                     if(state.rewards[_data.reward] !== undefined){
                //                         _data.newtype = state.rewards[_data.reward].newtype
                //                         _data.reward_currency = state.rewards[_data.reward].reward_currency
                //                     } else {
                //                         if(state.rewardsCompany[_data.reward]){
                //                             _data.newtype = state.rewardsCompany[_data.reward].newtype
                //                             _data.reward_currency = state.rewardsCompany[_data.reward].reward_currency
                //                         }else{
                //                             _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
                //                         }
                //                     }

                //                     /* For reward has been deleted */
                //                     if(_data.reward_currency == undefined){
                //                         _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
                //                     }
                //                     /* End For reward has been deleted */

                //                     if(_data.reward_currency && billing_pending[_data.reward_currency] == undefined){
                //                         billing_pending[_data.reward_currency] = []
                //                     }
                //                     if(billing_pending[_data.reward_currency]['reward_pending'] == undefined){
                //                         billing_pending[_data.reward_currency]['reward_pending'] = 0
                //                     }
                //                     if(_data.newtype && _data.newtype == 'Item'){
                //                         if((_data.feerate !== undefined && Number(_data.feerate) !== 0) || (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
                //                             if(_data.feerate && _data.feerate_happily){
                //                                 if(_data.feerate_happily > _data.feerate){
                //                                     _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
                //                                 }else{
                //                                     _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
                //                                 }
                //                             }else if(_data.feerate){
                //                                 _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
                //                             }else if(_data.feerate_happily){
                //                                 _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
                //                             }
                //                         }
                //                         if(_data.taxrate && _data.taxrate > 0){
                //                             _data.price = Number(_data.price) + ((Number(_data.price) * Number(_data.taxrate))/100)
                //                         }
                //                         billing_pending[_data.reward_currency]['reward_pending'] += Number(_data.price)
                //                         reward_pending += Number(_data.price)
                //                     }else{
                //                         if((_data.feerate !== undefined && Number(_data.feerate) !== 0) && (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
                //                             if(_data.feerate_happily > _data.feerate){
                //                                 calfee =  (Number(_data.price) * _data.feerate_happily) / 100
                //                             }else{
                //                                 calfee =  (Number(_data.price) * _data.feerate) / 100
                //                             }
                //                             if(_data.taxrate && _data.taxrate > 0){
                //                                 let caltax = (calfee * Number(_data.taxrate))/100
                //                                 priceFee = Number(_data.price) + Number(calfee) + Number(caltax)
                //                             }else{
                //                                 priceFee = Number(_data.price) + Number(calfee)
                //                             }
                //                             billing_pending[_data.reward_currency]['reward_pending'] += Number(priceFee)
                //                             reward_pending += Number(priceFee)
                //                         } else if(_data.feerate !== undefined && Number(_data.feerate) !== 0){
                //                             calfee =  (Number(_data.price) * _data.feerate) / 100
                //                             if(_data.taxrate && _data.taxrate > 0){
                //                                 let caltax = (calfee * Number(_data.taxrate))/100
                //                                 priceFee = Number(_data.price) + Number(calfee) + Number(caltax)
                //                             }else{
                //                                 priceFee = Number(_data.price) + Number(calfee)
                //                             }
                //                             billing_pending[_data.reward_currency]['reward_pending'] += Number(priceFee)
                //                             reward_pending += Number(priceFee)
                //                         } else if(_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0){
                //                             calfee =  (Number(_data.price) * _data.feerate_happily) / 100
                //                             if(_data.taxrate && _data.taxrate > 0){
                //                                 let caltax = (calfee * Number(_data.taxrate))/100
                //                                 priceFee = Number(_data.price) + Number(calfee) + Number(caltax)
                //                             }else{
                //                                 priceFee = Number(_data.price) + Number(calfee)
                //                             }
                //                             billing_pending[_data.reward_currency]['reward_pending'] += Number(priceFee)
                //                             reward_pending += Number(priceFee)
                //                         } else if (_data.price !== undefined){
                //                             billing_pending[_data.reward_currency]['reward_pending'] += Number(_data.price)
                //                             reward_pending += Number(_data.price)
                //                         }else{
                //                             billing_pending[_data.reward_currency]['reward_pending'] += 0
                //                             reward_pending += 0
                //                         }
                //                     }
                //                     // reward_pending += _data.price ? Number(_data.price) : 0
                //                 }
                //             }
                //         });
                //         firebase.firestore().collection(`instant_reward_credit_trans`).where('company','==',user.company).get()
                //         .then(function (querySnapshot) {
                //             querySnapshot.forEach(function (doc) {
                //                 let _data = doc.data();
                //                 let option:Array<any> = []
                //                 option['label'] = format(_data.transaction_date, 'MMMM YYYY')
                //                 option['value'] = format(_data.transaction_date, 'YYYY-MM')
                //                 if(MonthTemp[option['value']] == undefined){
                //                     MonthTemp[option['value']] = option
                //                     MonthOpt.push(option)
                //                 }
                //             });
                //             MonthOpt = _.sortBy(MonthOpt, [function(o:any) { return o.value; }]).reverse()
                //             selectMonth = MonthOpt[0]
                //             commit('setMonthOfYearOpt', MonthOpt)
                //             commit('setSelectMonthOfYear', selectMonth)
                //             if(cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false){
                //                 billing_pending = []
                //                 if(cmpOpt.billing_currency && billing_pending[cmpOpt.billing_currency] == undefined){
                //                     billing_pending[cmpOpt.billing_currency] = []
                //                 }
                //                 if(billing_pending[cmpOpt.billing_currency]['reward_pending'] == undefined){
                //                     billing_pending[cmpOpt.billing_currency]['reward_pending'] = 0
                //                 }
                //                 billing_pending[cmpOpt.billing_currency]['reward_pending'] = reward_pending
                //             }
                //             commit('setBillingPending', billing_pending)
                //             commit('setRewardPending', reward_pending)
                //         });
                //     });
                // });
            }
        },
        async getBillingData({commit,dispatch,state,rootState}:any, user:any){
            const {selectMonthOfYear} = state
            commit('setBillingData',[])
            commit('setLoading', true)
            let billing_summary:any = []
            let subscription:any = 0
            let reward_charges:any = 0
            let reward_credit_balance = 0
            let countries=countriesAndTimezone.getAllCountries()
            let countriesInCompany:Array<any>=[]
  
            // let reward_pending = 0
            const dateNow = new Date()
            const billingInfo = (await firebase.database().ref(`billing_info/${user.company}`).once('value')).val()
            const checkDate = `${format(dateNow,'YYYY-MM')}-${(billingInfo && billingInfo.billing_day !== undefined) ? `${billingInfo.billing_day}` : '20'}`
            let monthofyear = ''
            if(dateNow > new Date(checkDate)){
                let setDate = dateNow
                setDate.setMonth(setDate.getMonth() + 1);
                monthofyear = (selectMonthOfYear)?selectMonthOfYear.value:format(setDate, 'YYYY-MM')
            }else{
                monthofyear = (selectMonthOfYear)?selectMonthOfYear.value:format(dateNow, 'YYYY-MM')
            }
            
            const splitMOY = monthofyear.split('-')
            const thisYear = splitMOY[0]
            const thisMonth = splitMOY[1]
            const cmpOpt = await getCompany(user.company)//(await firebase.database().ref(`company/${user.company}`).once('value')).val()
            const allUser = await getUserAll(user.company)//rootState.main.allUser//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
            const allteam = await getTeamByCompany(user.company)//rootState.main.allTeam// (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
            let currency = 'THB'
            let companySymbol = 'THB'
            let allSymbolByKey = (await firebase.database().ref('currency').once('value')).val()
            const tax = (await firebase.database().ref('tax_rate').once('value')).val()
            
            let startDate = globalfunc.calculateStartDate(thisYear,thisMonth,(billingInfo && billingInfo.billing_day !== undefined) ? billingInfo.billing_day : '20')
            startDate = format(startDate, 'YYYY-MM-DD')
            const splitStartDate = startDate.split('-')
            const startYear = splitStartDate[0]
            const startMonth = splitStartDate[1]
            const startDay = splitStartDate[2]
            let endDate = `${monthofyear}-${(billingInfo && billingInfo.billing_day !== undefined) ? `${billingInfo.billing_day}` : '20'}`
            if(selectMonthOfYear !== '' && selectMonthOfYear.value){
                let splitCheckDate = selectMonthOfYear.value.split('-')
                if(Number(splitCheckDate[0]+splitCheckDate[1]) < 202409){
                    startDate = `${selectMonthOfYear.value}-01`
                    endDate = `${selectMonthOfYear.value}-31`
                }
            }
            let allSymbol: Array<any> = [];
            if(cmpOpt.billing_currency){
                currency = cmpOpt.billing_currency
            }
            if(Object.keys(allSymbolByKey).length > 0){
                let currencyData:any = _.find(allSymbolByKey, { currency: currency });
                companySymbol = (currencyData && currencyData.currency)?currencyData.currency:'THB'
                _.forEach(allSymbolByKey, (item, key) => {
                  allSymbol[item.currency] = (item && item.symbol)?item.symbol:'฿'
                });
            }
            reward_credit_balance = (cmpOpt !== undefined && cmpOpt.instant_reward_price) ? Number(cmpOpt.instant_reward_price) : 0
            let symbol = ''
            if(cmpOpt.billing_currency){
                symbol = allSymbol[cmpOpt.billing_currency]
            }else{
                symbol = '฿'
            }
            let CompanyVat = (cmpOpt && cmpOpt.country && cmpOpt.country == 'TH') ? 7 : 0
            let html = await dispatch('getExportHTML')
            html = html.replace(/{==COMPANY_VAT==}/g, CompanyVat);
            html = html.replace(/{==COMPANY_NAME==}/g, cmpOpt.name);
            
            if(cmpOpt !== undefined && cmpOpt.wallet !== undefined && cmpOpt.wallet_multiple !== undefined && cmpOpt.wallet_multiple == true){
                _.forEach(cmpOpt.wallet, (item, key) => {
                    if(key && billing_summary[key] == undefined){
                        billing_summary[key] = []
                    }
                    if(billing_summary[key]['reward_charges'] == undefined){
                        billing_summary[key]['reward_charges'] = 0
                    }
                    if(billing_summary[key]['reward_credit_balance'] == undefined){
                        billing_summary[key]['reward_credit_balance'] = 0
                    }
                    if(billing_summary[key]['topupCredit'] == undefined){
                        billing_summary[key]['topupCredit'] = 0
                    }
                    billing_summary[key]['reward_credit_balance'] = Number(item)
                });
            }
            const countryMember={}
            const filterCountry=_.filter(allUser,function (value) {return value.country !== undefined;});
            let countryInCompany = _.groupBy(filterCountry, function (b) {
                return b.country;
              });
            
            for(let country in countryInCompany){
                if(countries[country]){
                    countriesInCompany.push({country:countries[country].name,id:country})
                }
                if(countryMember[country]==undefined){
                    countryMember[country]=[]
                }
            }
            
            
            commit('setCountryInCompany',countriesInCompany)
            let promise2:Array<any> = []
            var promise1 = new Promise(function(resolve, reject) {
                const data1:Array<any> = []
                let activeUserDay:Array<any> = []
                let activeUserArr:Array<any> = []
                let lastActivityArr:Array<any> = []
                //let _thisMonth=format(subMonths(thisMonth,1),"MM")//parseInt(thisMonth)-1
                let this_Month=format(subMonths(new Date(monthofyear),1),"MM")//_thisMonth<10?"0"+_thisMonth.toString():_thisMonth.toString()
                const this_Year=format(subMonths(new Date(monthofyear),1),"YYYY")
                firebase.firestore().collection(`active_users_day`).where("company","==",user.company).where("date", ">=", `${startDate} 00:00:00`).where("date", "<", `${endDate} 23:59:59`).orderBy('date','asc').get()
                // firebase.firestore().collection(`active_users`).where('company','==',user.company).where('year','==',this_Year).where('month','==',this_Month).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        let _data = doc.data();
                        lastActivityArr[_data.email] = format(_data.date, 'MM-DD-YYYY HH:mm:ss')
                        if(activeUserDay[_data.email] == undefined){
                            activeUserDay[_data.email] = _data
                            activeUserArr.push(_data)
                        }
                    });
                    if (activeUserArr.length > 0) {
                        _.forEach(activeUserArr, (value, index) => {
                            activeUserArr[index].lastactivity = lastActivityArr[value.email]
                        });
                        activeUserArr = _.sortBy(activeUserArr, [function(o) { return o.lastactivity; }]);
                        _.forEach(activeUserArr, (value, index) => {
                            let emailKey = value.email.replace(/\./g, "||")
                            let _item:Array<any> = []
                            _item['firstname'] = allUser[emailKey] ? allUser[emailKey].firstname : "(Deleted)"
                            _item['lastname'] = allUser[emailKey] ? allUser[emailKey].lastname : ""
                            _item['email'] = value.email
                            _item['team_name'] = (allUser[emailKey] && allUser[emailKey].team && allteam[allUser[emailKey].team]) ? allteam[allUser[emailKey].team].name : ""
                            if(allUser[emailKey] && allUser[emailKey]['profilepic_small']){
                                _item['pic'] = allUser[emailKey]['profilepic_small'];
                            }else if (allUser[emailKey] && allUser[emailKey]['profilepic_crop']){
                                _item['pic'] = allUser[emailKey]['profilepic_crop'];
                            }else if (allUser[emailKey] && [emailKey]['profilepic']){
                                _item['pic'] = allUser[emailKey]['profilepic'];
                            }else {
                                _item['pic'] = "";
                            }
                            const lastDate=format(value.lastactivity, 'YYYY-MM-DD')+' '+format(value.lastactivity, 'HH:mm:ss')
                            let time=format(new Date(lastDate), "MMM-D-YYYY h:mm A")
                            const textTime=time.split(" ")
                            _item['lastDate']=format(new Date(value.lastactivity), "MMM D YYYY")
                            _item['time']=textTime[1]+" "+textTime[2]
                            promise2.push(_item)
                            if(allUser[emailKey]){
                                if(allUser[emailKey].country){
                                    countryMember[allUser[emailKey].country].push(_item)
                                }
                                else{
                                    if(!countryMember["TH"]) countryMember["TH"] = [];
                                    countryMember["TH"].push(_item)
                                }
                                
                                
                            }
                            else{
                                if(!countryMember["TH"]) countryMember["TH"] = [];
                                countryMember["TH"].push(_item)
                            }
                        });
                        let temp:any = {};
                        let discount = (cmpOpt.discount != undefined)?cmpOpt.discount * 1: 0;
                        let lastDate:any
                        if(new Date(endDate) > dateNow){
                            lastDate = format(dateNow,'YYYY-MM-DD HH:mm:ss')
                        }else{
                            lastDate = format(new Date(endDate),'YYYY-MM-DD HH:mm:ss')
                        }
                        temp.table_date = format(lastDate, 'MMMM D, YYYY')
                        temp.table_category = 'Subscription'
                        temp.table_description = `${format(startDate, 'MMM DD')} to ${format(lastDate, 'MMM DD, YYYY')}`
                        temp.table_status = (temp.status && temp.status == 'Y') ? 'bill-sent' : 'pending'
                        temp.price = (cmpOpt !== undefined ) ? cmpOpt.rate : 0;
                        temp.active_users = activeUserArr.length
                        if(cmpOpt.seat){
                            if(cmpOpt.seat == 'active_users'){
                                if(cmpOpt.minimum_users && cmpOpt.minimum_users > temp.active_users){
                                    temp.show_minimum = true;
                                    temp.totalnumber = (discount > 0)?(temp.price * cmpOpt.minimum_users) * (1 - (discount / 100)):temp.price * cmpOpt.minimum_users;
                                }else{
                                    temp.totalnumber = (discount > 0)?(temp.price * temp.active_users) * (1 - (discount / 100)):temp.price * temp.active_users;
                                }
                            }else if(cmpOpt.seat == 'fixed_users'){
                                temp.show_minimum = true;
                                temp.totalnumber = (discount > 0)?(temp.price * cmpOpt.minimum_users) * (1 - (discount / 100)):temp.price * cmpOpt.minimum_users;
                            }
                        }else{
                            temp.totalnumber = (discount > 0)?(temp.price * temp.active_users) * (1 - (discount / 100)):temp.price * temp.active_users;
                        }
                        temp.total = temp.totalnumber
                        temp.sortdate = lastDate
                        if(cmpOpt.billing_currency && billing_summary[cmpOpt.billing_currency] == undefined){
                            billing_summary[cmpOpt.billing_currency] = []
                        }
                        if(billing_summary[cmpOpt.billing_currency]['subscription'] == undefined){
                            billing_summary[cmpOpt.billing_currency]['subscription'] = 0
                        }
                        billing_summary[cmpOpt.billing_currency]['subscription'] = Number(temp.total)
                        subscription = Number(temp.total)
                        data1.push(temp)
                        html = html.replace(/{==DATE==}/g, temp.table_description);
                    }
                    if(data1.length > 0){
                        let _data = data1[0]
                        let vat = (_data.total * CompanyVat) / 100
                        let summary = _data.total + vat
                        let sucscriptionData = `<tr>
                                                    <td>Pro Subscription (Monthly)</td>
                                                    <td>${_data.active_users}</td>
                                                    <td>${symbol}${globalfunc.addCommasInNumber(_data.price,2)}</td>
                                                    <td>${symbol}${globalfunc.addCommasInNumber(_data.total,2)}</td>
                                                    <td></td>
                                                    <td>${symbol}${globalfunc.addCommasInNumber(_data.total,2)}</td>
                                                    <td>${symbol}${globalfunc.addCommasInNumber(vat,2)}</td>
                                                    <td>${symbol}${globalfunc.addCommasInNumber(summary,2)}</td>
                                                </tr>`
                        html = html.replace(/{==SUBSCRIPTION_SERVICES==}/g, sucscriptionData);
                    }else{
                        let sucscriptionData = `<tr>
                                                    <td>Pro Subscription (Monthly)</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>`
                        html = html.replace(/{==SUBSCRIPTION_SERVICES==}/g, sucscriptionData);
                    }
                    resolve(data1);
                });
            });
            // var promise1 = new Promise(function(resolve, reject) {
            //     const data1:Array<any> = []
      
            //     //let _thisMonth=format(subMonths(thisMonth,1),"MM")//parseInt(thisMonth)-1
            //     let this_Month=format(subMonths(new Date(monthofyear),1),"MM")//_thisMonth<10?"0"+_thisMonth.toString():_thisMonth.toString()
            //     const this_Year=format(subMonths(new Date(monthofyear),1),"YYYY")
            //     firebase.firestore().collection(`active_users`).where('company','==',user.company).where('year','==',this_Year).where('month','==',this_Month).get()
            //     .then(function (querySnapshot) {
            //         querySnapshot.forEach(function (doc) {
            //             let _data = doc.data();
            //             let discount = (_data.discount != undefined)?_data.discount: cmpOpt.discount * 1;
            //             _data.table_date = (_data.update) ? format(_data.update, 'MMMM D, YYYY') : format(_data.date, 'MMMM D, YYYY')
            //             _data.table_category = 'Subscription'
            //             _data.table_description = format(subMonths(new Date(monthofyear), 1), 'MMM YYYY')
            //             _data.table_status = (_data.status && _data.status == 'Y') ? 'bill-sent' : 'pending'
            //             _data.price = (cmpOpt !== undefined ) ? cmpOpt.rate : 0;
            //             if(_data.seat){
            //                 if(_data.seat == 'active_users'){
            //                     if(_data.minimum_users && _data.minimum_users > _data.active_users){
            //                         _data.show_minimum = true;
            //                         _data.totalnumber = (discount > 0)?(_data.price * _data.minimum_users) * (1 - (discount / 100)):_data.price * _data.minimum_users;
            //                     }else{
            //                         _data.totalnumber = (discount > 0)?(_data.price * _data.active_users) * (1 - (discount / 100)):_data.price * _data.active_users;
            //                     }
            //                 }else if(_data.seat == 'fixed_users'){
            //                     _data.show_minimum = true;
            //                     _data.totalnumber = (discount > 0)?(_data.price * _data.minimum_users) * (1 - (discount / 100)):_data.price * _data.minimum_users;
            //                 }
            //             }else{
            //                 _data.totalnumber = (discount > 0)?(_data.price * _data.active_users) * (1 - (discount / 100)):_data.price * _data.active_users;
            //             }
            //             _data.total = _data.totalnumber
            //             _data.sortdate = _data.update
            //             if(cmpOpt.billing_currency && billing_summary[cmpOpt.billing_currency] == undefined){
            //                 billing_summary[cmpOpt.billing_currency] = []
            //             }
            //             if(billing_summary[cmpOpt.billing_currency]['subscription'] == undefined){
            //                 billing_summary[cmpOpt.billing_currency]['subscription'] = 0
            //             }
            //             billing_summary[cmpOpt.billing_currency]['subscription'] = Number(_data.total)
            //             subscription = Number(_data.total)
            //             // if(_data.status == 'Y'){
            //             //     reward_charges += _data.total
            //             // }
            //             // else{
            //             //     reward_pending += _data.total
            //             // }
            //             data1.push(_data)
            //         });
            //         if(data1.length > 0){
            //             let _data = data1[0]
            //             let vat = (_data.total * CompanyVat) / 100
            //             let summary = _data.total + vat
            //             let sucscriptionData = `<tr>
            //                                         <td>Pro Subscription (Monthly)</td>
            //                                         <td>${_data.active_users}</td>
            //                                         <td>${symbol}${globalfunc.addCommasInNumber(_data.price,2)}</td>
            //                                         <td>${symbol}${globalfunc.addCommasInNumber(_data.total,2)}</td>
            //                                         <td></td>
            //                                         <td>${symbol}${globalfunc.addCommasInNumber(_data.total,2)}</td>
            //                                         <td>${symbol}${globalfunc.addCommasInNumber(vat,2)}</td>
            //                                         <td>${symbol}${globalfunc.addCommasInNumber(summary,2)}</td>
            //                                     </tr>`
            //             html = html.replace(/{==SUBSCRIPTION_SERVICES==}/g, sucscriptionData);
            //         }else{
            //             let sucscriptionData = `<tr>
            //                                         <td>Pro Subscription (Monthly)</td>
            //                                         <td></td>
            //                                         <td></td>
            //                                         <td></td>
            //                                         <td></td>
            //                                         <td></td>
            //                                         <td></td>
            //                                         <td></td>
            //                                     </tr>`
            //             html = html.replace(/{==SUBSCRIPTION_SERVICES==}/g, sucscriptionData);
            //         }
            //         resolve(data1);
            //     });
            // });
            // var promise2 = new Promise(function(resolve, reject) {
            //     const data2:Array<any> = []
            //     //let _thisMonth=parseInt(thisMonth)-1
            //     //let this_Month=format(subMonths(thisMonth,1),"MM") _thisMonth<10?"0"+_thisMonth.toString():_thisMonth.toString()
                
            //     const active_date=format(subMonths(new Date(`${thisYear}-${thisMonth}`),1),"YYYY-MM")//thisYear+"-"+this_Month
            //     firebase.firestore().collection('active_users').doc(`${user.company}-${active_date}`).collection('users').orderBy('lastupdate').get()
            //     .then(function (querySnapshot) {
            //         querySnapshot.forEach(function (doc) {
            //             const data = doc.data();
            //             let emailKey = data.email.replace(/\./g, "||")
            //             let _item:Array<any> = []
            //             _item['firstname'] = allUser[emailKey] ? allUser[emailKey].firstname : "(Deleted)"
            //             _item['lastname'] = allUser[emailKey] ? allUser[emailKey].lastname : ""
            //             _item['email'] = data.email
            //             _item['team_name'] = (allUser[emailKey] && allUser[emailKey].team && allteam[allUser[emailKey].team]) ? allteam[allUser[emailKey].team].name : ""
            //             if(allUser[emailKey] && allUser[emailKey]['profilepic_small']){
            //                 _item['pic'] = allUser[emailKey]['profilepic_small'];
            //               }else if (allUser[emailKey] && allUser[emailKey]['profilepic_crop']){
            //                 _item['pic'] = allUser[emailKey]['profilepic_crop'];
            //               }else if (allUser[emailKey] && [emailKey]['profilepic']){
            //                 _item['pic'] = allUser[emailKey]['profilepic'];
            //               }else {
            //                 _item['pic'] = "";
            //               }
            //             const lastDate=data.lastupdate+' '+data.time
            //             let time=format(new Date(lastDate), "MMM-D-YYYY h:mm A")
            //             const textTime=time.split(" ")
            //             _item['lastDate']=format(new Date(data.lastupdate), "MMM D YYYY")
            //             _item['time']=textTime[1]+" "+textTime[2]
            //             data2.push(_item)
            //             if(allUser[emailKey]){
            //                 if(allUser[emailKey].country){
            //                     // if(countryMember[allUser[emailKey].country]==undefined){
            //                     //     countryMember[allUser[emailKey].country]=[]
            //                     // }
            //                     countryMember[allUser[emailKey].country].push(_item)
            //                 }
            //                 else{
            //                     if(!countryMember["TH"]) countryMember["TH"] = [];
            //                     countryMember["TH"].push(_item)
            //                 }
                            
                            
            //             }
            //             else{
            //                 if(!countryMember["TH"]) countryMember["TH"] = [];
            //                 countryMember["TH"].push(_item)
            //             }
                        
            //         });
            //         resolve(data2);
            //     });
            // });
            var promise3 = new Promise(function(resolve, reject) {
                const data3:Array<any> = []
                firebase.firestore().collection(`instant_reward_credit_trans`).where('company','==',user.company).where('transaction_date','>=',`${startDate}`).where('transaction_date','<=',`${endDate}`).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        let _data = doc.data()
                        _data.table_date = format(_data.transaction_date, 'MMMM D, YYYY')
                        _data.table_category = 'Rewards'
                        _data.table_description = 'Top-up Credits'
                        _data.table_status = 'charged'
                        _data.total = _data.amount
                        _data.sortdate = _data.transaction_date
                        if(data3[_data.credit_currency] == undefined){
                            data3[_data.credit_currency] = []
                        }
                        data3[_data.credit_currency].push(_data)
                    });
                    resolve(data3);
                });
            });
            const redeemRewardsData:Array<any> = []
            var promise_4_new = new Promise(function(resolve, reject) {
                const currency_rate:Array<any> = []
                const currency_rate_Data:Array<any> = []
                firebase.firestore().collection(`redeem_rewards`).where('company','==',user.company).where('updated','>=',`${startDate} 00:00:00`).where('updated','<=',`${endDate} 23:59:59`).orderBy('updated').get()
                .then(async function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        let _data = doc.data()
                        // if(doc.id == _data.redeem_rewards_id){
                        if(_data.type !== 'gift' || (_data.type == 'gift' && doc.id.slice(-2) !== '-2')){ //Detect Gift type rewards will have 2 records.
                            if(state.rewards[_data.reward] !== undefined){
                                _data.reward_currency = state.rewards[_data.reward].reward_currency
                            } else if(state.rewardsCompany[_data.reward]){
                                _data.reward_currency = state.rewardsCompany[_data.reward].reward_currency
                            }else{
                                _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
                            }

                            /* For reward has been deleted */
                            if(_data.reward_currency == undefined){
                                _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
                            }
                            /* End For reward has been deleted */
                            if(_data['exchangerate'] && _data['exchangerate'].target_code){
                                _data.reward_currency = _data['exchangerate'].target_code
                            }
                            if(cmpOpt && cmpOpt.billing_currency !== _data.reward_currency && (cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false) && _data['exchangerate'] == undefined){
                                if(currency_rate[_data.reward_currency+'_to_'+cmpOpt.billing_currency] == undefined){
                                    currency_rate[_data.reward_currency+'_to_'+cmpOpt.billing_currency] = true
                                }
                            }
                            redeemRewardsData.push(_data)
                        }
                    });
                    if(currency_rate && Object.keys(currency_rate).length > 0){
                        for(const i in currency_rate){
                            let currArr = i.split("_to_");
                            let from = currArr[0];
                            let to = currArr[1];
                            var axios = require('axios');
                            const config = {
                                method: 'get',
                                url: `https://api-node.happily.ai/wogi/exchagerate/${from}/${to}/${1}`,
                                headers: {
                                'Content-Type': 'application/json'
                                },
                                data : ''
                            };
                            await axios(config)
                            .then(response => {
                                if(response.data.result === 'success'){
                                    let price = response.data.conversion_result;
                                    currency_rate_Data[from+'_to_'+to] = price
                                }
                            })
                        }
                    }
                    resolve(currency_rate_Data);
                });
            });
            // var promise4 = new Promise(function(resolve, reject) {
            //     const data4:Array<any> = []
            //     firebase.firestore().collection(`redeem_rewards`).where('company','==',user.company).where('updated','>=',`${monthofyear}-01 00:00:00`).where('updated','<=',`${monthofyear}-31 23:59:59`).orderBy('updated').get()
            //     .then(function (querySnapshot) {
            //         querySnapshot.forEach(function (doc) {
            //             let _data = doc.data()
            //             if(doc.id == _data.redeem_rewards_id){
            //                 let calfee:any
            //                 if(_data['exchangerate'] && _data['exchangerate'].conversion_result){
            //                     _data.price = _data['exchangerate'].conversion_result
            //                 }
            //                 if((_data.feerate !== undefined && Number(_data.feerate) !== 0) && (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
            //                     if(_data.feerate_happily > _data.feerate){
            //                         calfee =  (Number(_data.price) * _data.feerate_happily) / 100
            //                     }else{
            //                         calfee =  (Number(_data.price) * _data.feerate) / 100
            //                     }
            //                 } else if(_data.feerate !== undefined && Number(_data.feerate) !== 0){
            //                     calfee =  (Number(_data.price) * _data.feerate) / 100
            //                 } else if(_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0){
            //                     calfee =  (Number(_data.price) * _data.feerate_happily) / 100
            //                 }else if(Number(_data.price) !== undefined && Number(_data.price) !== 0){
            //                     _data.price = Number(_data.price)
            //                 }else{
            //                     _data.price = 0
            //                 }
            //                 // _data.price = _data.price !== undefined ? _data.price : 0
            //                 // _data.name = state.rewards[_data.reward] !== undefined ? state.rewards[_data.reward].reward : state.rewardsCompany[_data.reward].reward + ' (Custom)',
                           
            //                 if(state.rewards[_data.reward] !== undefined){
            //                     _data.name = state.rewards[_data.reward].reward
            //                     _data.country = state.rewards[_data.reward].country !== undefined ? state.rewards[_data.reward].country : ''
            //                     _data.newtype = state.rewards[_data.reward].newtype
            //                     _data.reward_currency = state.rewards[_data.reward].reward_currency
            //                 } else if(state.rewardsCompany[_data.reward]){
            //                     _data.name = state.rewardsCompany[_data.reward].reward + ' (Custom)'
            //                     _data.country = state.rewardsCompany[_data.reward].country !== undefined ? state.rewardsCompany[_data.reward].country : ''
            //                     _data.newtype = state.rewardsCompany[_data.reward].newtype
            //                     _data.reward_currency = state.rewardsCompany[_data.reward].reward_currency
            //                 }else{
            //                     _data.name = 'THE REWARD HAS BEEN REMOVED'
            //                     _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
            //                 }

            //                 /* For reward has been deleted */
            //                 if(_data.reward_currency == undefined){
            //                     _data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
            //                 }
            //                 /* End For reward has been deleted */

            //                 if(_data.reward_currency && billing_summary[_data.reward_currency] == undefined){
            //                     billing_summary[_data.reward_currency] = []
            //                 }
            //                 if(billing_summary[_data.reward_currency]['reward_charges'] == undefined){
            //                     billing_summary[_data.reward_currency]['reward_charges'] = 0
            //                 }
            //                 if(_data['exchangerate'] && _data['exchangerate'].target_code){
            //                     _data.symbol = state.allSymbol[_data['exchangerate'].target_code]
            //                 }else{
            //                     if(_data.reward_currency){
            //                         _data.symbol = state.allSymbol[_data.reward_currency]
            //                     }else{
            //                         _data.symbol = '฿'
            //                     }
            //                 }
            //                 if(_data.newtype && _data.newtype == 'Item'){
            //                     if((_data.feerate !== undefined && Number(_data.feerate) !== 0) || (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
            //                         if(_data.feerate && _data.feerate_happily){
            //                             if(_data.feerate_happily > _data.feerate){
            //                                 _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
            //                                 _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
            //                             }else{
            //                                 _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
            //                                 _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
            //                             }
            //                         }else if(_data.feerate){
            //                             _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
            //                             _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
            //                         }else if(_data.feerate_happily){
            //                             _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
            //                             _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
            //                         }
                                    
            //                     }
            //                     if(_data.taxrate && _data.taxrate > 0){
            //                         if(_data.detail_txt){
            //                             _data.detail_txt += ` & Tax (${_data.taxrate}%)`
            //                         }else{
            //                             _data.detail_txt = `Excluding Tax (${_data.taxrate}%)`
            //                         }
            //                         _data.price = Number(_data.price) + ((Number(_data.price) * Number(_data.taxrate))/100)
            //                     }
            //                 }else{
            //                     if((_data.feerate !== undefined && Number(_data.feerate) !== 0) || (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
            //                         if(_data.feerate && _data.feerate_happily){
                                       
            //                             if(_data.feerate_happily > _data.feerate){
            //                                 _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
            //                             }else{
            //                                 _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
            //                             }
            //                         }else if(_data.feerate){
            //                             _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
            //                         }else if(_data.feerate_happily){
            //                             _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
            //                         }
            //                         if(_data.taxrate && _data.taxrate > 0){
            //                             _data.detail_txt += ` & Tax (${Number.parseFloat(_data.taxrate).toFixed()}%)`
            //                             let caltax = (calfee * Number(_data.taxrate))/100
            //                             _data.price = Number(_data.price) + Number(calfee) + Number(caltax)
            //                         }else{
            //                             if(calfee){
            //                                 _data.price = Number(_data.price) + Number(calfee)
            //                             }
            //                         }
            //                     }
            //                 }
            //                 _data.table_date = format(_data.updated, 'MMMM D, YYYY')
            //                 _data.table_category = 'Rewards'
            //                 _data.table_description = 'Redeemed - '+_data.name
            //                 _data.total = _data.price
            //                 _data.sortdate = _data.updated
            //                 // if(_data.type == 'gem'){
            //                     // _data.table_status = 'charged'
            //                 // }else{
            //                 if(_data.status == 'Y' || _data.status_send == 'SC'){
            //                     _data.table_status = 'charged'
            //                     if(_data.price){
            //                         billing_summary[_data.reward_currency]['reward_charges'] += Number(_data.price)
            //                         reward_charges += Number(_data.price)
            //                     }
            //                 }
            //                 // else{
            //                 //     _data.table_status = 'Pending'
            //                 //     reward_pending += _data.price
            //                 // }
            //                 _data.table_status = (_data.status == 'Y')?'charged':(_data.status == 'X' || _data.status == 'C')?'canceled':'pending'
            //                 // }
            //                 data4.push(_data)
            //             }
            //         });
            //         resolve(data4);
            //     });
            // });
            // var promise5 = new Promise(function(resolve, reject) {
            //     let data5 = 0
            //     firebase.firestore().collection(`instant_reward_credit_trans`).where('company','==',user.company).get()
            //     .then(function (querySnapshot) {
            //         querySnapshot.forEach(function (doc) {
            //             let _data = doc.data()
            //             data5 += _data.amount
            //         });
            //         resolve(data5);
            //     });
            // });
            Promise.all([promise1, promise2, promise3,promise_4_new]).then(async (values)=> {
                const data1:any = values[0]
                const data2:any = values[1]
                const data3:any = values[2]
                const currencyRateOtp:any = values[3]
                const data4:Array<any> = []
                let billing_rewards:Array<any> = []
                _.forEach(redeemRewardsData, (item:any) => {
                    let _data = item
                    let calfee:any
                    if(_data['exchangerate'] && _data['exchangerate'].conversion_result){
                        _data.price = _data['exchangerate'].conversion_result
                    }
                    if(_data.feerate == undefined){
                        if(state.rewards[_data.reward] !== undefined){
                            _data.feerate = state.rewards[_data.reward].feerate
                        } else if(state.rewardsCompany[_data.reward]){
                            _data.feerate = state.rewardsCompany[_data.reward].feerate
                        }
                    }
                    if(_data.feerate_happily == undefined){
                        if(state.rewards[_data.reward] !== undefined){
                            _data.feerate_happily = state.rewards[_data.reward].feerate_happily
                        } else if(state.rewardsCompany[_data.reward]){
                            _data.feerate_happily = state.rewardsCompany[_data.reward].feerate_happily
                        }
                    }
                    if(_data.price !== undefined && Number(_data.price) !== 0){
                        _data.price = Number(_data.price)
                    }else{
                        if(state.rewards[_data.reward] !== undefined && state.rewards[_data.reward].price){
                            _data.price = Number(state.rewards[_data.reward].price)
                        } else if(state.rewardsCompany[_data.reward] && state.rewardsCompany[_data.reward].price){
                            _data.price = Number(state.rewardsCompany[_data.reward].price)
                        }else{
                            _data.price = 0
                        }
                    }
                    if((_data.feerate !== undefined && Number(_data.feerate) !== 0) && (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
                        if(_data.feerate_happily > _data.feerate){
                            calfee =  (Number(_data.price) * _data.feerate_happily) / 100
                        }else{
                            calfee =  (Number(_data.price) * _data.feerate) / 100
                        }
                    } else if(_data.feerate !== undefined && Number(_data.feerate) !== 0){
                        calfee =  (Number(_data.price) * _data.feerate) / 100
                    } else if(_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0){
                        calfee =  (Number(_data.price) * _data.feerate_happily) / 100
                    }
                    
                    if(state.rewards[_data.reward] !== undefined){
                        _data.name = state.rewards[_data.reward].reward_en
                        _data.country = state.rewards[_data.reward].country !== undefined ? state.rewards[_data.reward].country : ''
                        _data.newtype = state.rewards[_data.reward].newtype
                        if(_data.taxrate == undefined && _data.country && tax[_data.country]) {
                            _data.taxrate = tax[_data.country].rate;
                        }
                    } else if(state.rewardsCompany[_data.reward]){
                        _data.name = state.rewardsCompany[_data.reward].reward_en + ' (Custom)'
                        _data.country = state.rewardsCompany[_data.reward].country !== undefined ? state.rewardsCompany[_data.reward].country : ''
                        _data.newtype = state.rewardsCompany[_data.reward].newtype
                        if(_data.taxrate == undefined && _data.country && tax[_data.country]) {
                            _data.taxrate = tax[_data.country].rate;
                        }
                    }else{
                        _data.name = 'THE REWARD HAS BEEN REMOVED'
                    }

                    if(_data.reward_currency && billing_summary[_data.reward_currency] == undefined){
                        billing_summary[_data.reward_currency] = []
                    }
                    if(billing_summary[_data.reward_currency]['reward_charges'] == undefined){
                        billing_summary[_data.reward_currency]['reward_charges'] = 0
                    }
                    if(_data['exchangerate'] && _data['exchangerate'].target_code){
                        _data.symbol = allSymbol[_data['exchangerate'].target_code]
                    }else{
                        if(_data.reward_currency){
                            _data.symbol = allSymbol[_data.reward_currency]
                        }else{
                            _data.symbol = '฿'
                        }
                    }
                    if(cmpOpt && cmpOpt.billing_currency !== _data.reward_currency && (cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false) && _data['exchangerate'] == undefined){
                        if(currencyRateOtp[_data.reward_currency+'_to_'+cmpOpt.billing_currency] !== undefined){
                            _data.price = Number(_data.price) * Number(currencyRateOtp[_data.reward_currency+'_to_'+cmpOpt.billing_currency])
                            _data.symbol = allSymbol[cmpOpt.billing_currency]
                        }
                    }
                    _data.firstprice = Number(_data.price)
                    if(_data.newtype && _data.newtype == 'Item'){ // Merchandise
                        if((_data.feerate !== undefined && Number(_data.feerate) !== 0) || (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
                            if(_data.feerate && _data.feerate_happily){
                                if(_data.feerate_happily > _data.feerate){
                                    _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
                                    _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
                                    _data.firstfee = (Number(_data.firstprice) * _data.feerate_happily) / 100
                                }else{
                                    _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
                                    _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
                                    _data.firstfee = (Number(_data.firstprice) * _data.feerate) / 100
                                }
                            }else if(_data.feerate){
                                _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
                                _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate) / 100)
                                _data.firstfee = (Number(_data.firstprice) * _data.feerate) / 100
                            }else if(_data.feerate_happily){
                                _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
                                _data.price =  Number(_data.price) + ((Number(_data.price) * _data.feerate_happily) / 100)
                                _data.firstfee = (Number(_data.firstprice) * _data.feerate_happily) / 100
                            }
                            
                        }
                        if(_data.taxrate && _data.taxrate > 0){
                            if(_data.detail_txt){
                                _data.detail_txt += ` & Tax111 (${_data.taxrate}%)`
                            }else{
                                _data.detail_txt = `Excluding Tax (${_data.taxrate}%)`
                            }
                            _data.price = Number(_data.price) + ((Number(_data.price) * Number(_data.taxrate))/100)
                            _data.firsttax = (Number(_data.firstprice) * Number(_data.taxrate))/100
                        }
                    }else{
                        if((_data.feerate !== undefined && Number(_data.feerate) !== 0) || (_data.feerate_happily !== undefined && Number(_data.feerate_happily) !== 0)){
                            if(_data.feerate && _data.feerate_happily){
                                
                                if(_data.feerate_happily > _data.feerate){
                                    _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
                                }else{
                                    _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
                                }
                            }else if(_data.feerate){
                                _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate).toFixed()}%)`
                            }else if(_data.feerate_happily){
                                _data.detail_txt = `Excluding Processing Fee (${Number.parseFloat(_data.feerate_happily).toFixed()}%)`
                            }
                            if(_data.taxrate && _data.taxrate > 0){
                                _data.detail_txt += ` & Tax (${Number.parseFloat(_data.taxrate).toFixed()}%)`
                                let caltax = (calfee * Number(_data.taxrate))/100
                                _data.price = Number(_data.price) + Number(calfee) + Number(caltax)
                                _data.firstfee = Number(calfee)
                                _data.firsttax = Number(caltax)
                            }else{
                                if(calfee){
                                    _data.price = Number(_data.price) + Number(calfee)
                                    _data.firstfee = Number(calfee)
                                }
                            }
                        }
                    }
                    _data.table_date = format(_data.updated, 'MMMM D, YYYY')
                    _data.table_category = 'Rewards'
                    _data.table_description = 'Redeemed - '+_data.name
                    _data.total = _data.firstprice
                    _data.sortdate = _data.updated
                    // if(_data.type == 'gem'){
                        // _data.table_status = 'charged'
                    // }else{
                    if(_data.status == 'Y' || _data.status_send == 'SC'){
                        _data.table_status = 'charged'
                        if(_data.firstprice){
                            billing_summary[_data.reward_currency]['reward_charges'] += Number(_data.firstprice)
                            reward_charges += Number(_data.firstprice)
                        }
                    }
                    // else{
                    //     _data.table_status = 'Pending'
                    //     reward_pending += _data.price
                    // }
                    _data.table_status = (_data.status == 'Y')?'charged':(_data.status == 'X' || _data.status == 'C')?'canceled':'pending'
                    // }
                    
                    if(_data.reward_currency && billing_rewards[_data.reward_currency] == undefined){
                        billing_rewards[_data.reward_currency] = []
                    }
                    if(_data.status == 'Y' || _data.status_send == 'SC'){
                        if(billing_rewards[_data.reward_currency]['transacted'] == undefined){
                            billing_rewards[_data.reward_currency]['transacted'] = []
                        }
                        // billing_rewards[_data.reward_currency]['transacted'].push(_data)
                        let indexKey = `${_data.reward}-${_data.price}`;
                        if (billing_rewards[_data.reward_currency]['transacted'][indexKey] === undefined) {
                            billing_rewards[_data.reward_currency]['transacted'][indexKey] = {
                                name : _data.name,
                                firstprice : _data.firstprice ? _data.firstprice : 0,
                                firstfee : _data.firstfee ? _data.firstfee : 0,
                                firsttax : _data.firsttax ? _data.firsttax : 0,
                                price : _data.price,
                                qty: 1,
                                amout: _data.price ? _data.price * 1 : 0,
                                key : _data.redeem_rewards_id,
                                reward_currency : _data.reward_currency
                            };
                        } else {
                            billing_rewards[_data.reward_currency]['transacted'][indexKey].qty += 1;
                            billing_rewards[_data.reward_currency]['transacted'][indexKey].amout += _data.price * 1;
                        }
                    }else if(_data.status == 'X' || _data.status == 'C'){
                    }else{
                        if(billing_rewards[_data.reward_currency]['pending'] == undefined){
                            billing_rewards[_data.reward_currency]['pending'] = []
                        }
                        // billing_rewards[_data.reward_currency]['pending'].push(_data)
                        let indexKey = `${_data.reward}-${_data.price}`;
                        if (billing_rewards[_data.reward_currency]['pending'][indexKey] === undefined) {
                            billing_rewards[_data.reward_currency]['pending'][indexKey] = {
                                name : _data.name,
                                firstprice : _data.firstprice ? _data.firstprice : 0,
                                firstfee : _data.firstfee ? _data.firstfee : 0,
                                firsttax : _data.firsttax ? _data.firsttax : 0,
                                price : _data.price,
                                qty: 1,
                                amout: _data.price ? _data.price * 1 : 0,
                                key : _data.redeem_rewards_id,
                                reward_currency : _data.reward_currency
                            };
                        } else {
                            billing_rewards[_data.reward_currency]['pending'][indexKey].qty += 1;
                            billing_rewards[_data.reward_currency]['pending'][indexKey].amout += _data.price * 1;
                        }
                    }
                    data4.push(_data)
                });
                let htmlRewards = await dispatch('getRewardsHTML',{billing_summary,billing_rewards,CompanyVat, allSymbol})
                html = html.replace(/{==REWARDS_TABLE==}/g, htmlRewards);
                let dataBilling = _.concat(data1)
                if(cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false){
                    billing_summary = []
                    if(cmpOpt.billing_currency && billing_summary[cmpOpt.billing_currency] == undefined){
                        billing_summary[cmpOpt.billing_currency] = []
                    }
                }
                if(Object.keys(data3).length > 0){
                    for(let currency in data3){
                        dataBilling = _.concat(dataBilling,data3[currency])
                        let topupCredit = 0
                        _.forEach(data3[currency], (item:any) => {
                            if(currency && billing_summary[currency] == undefined){
                                billing_summary[currency] = []
                            }
                            if(billing_summary[currency]['topupCredit'] == undefined){
                                billing_summary[currency]['topupCredit'] = 0
                            }
                            billing_summary[currency]['topupCredit'] += Number(item.total)
                            topupCredit += Number(item.total)
                        });
                    }
                    // _.forEach(data3, (item:any) => {
                    //     topupCredit+= Number(item.total)
                    // })
                    // commit('setTopupCredit', topupCredit)
                }else{
                    for(let currency in billing_summary){
                        billing_summary[currency]['topupCredit'] = 0
                    }
                    commit('setTopupCredit', 0)
                }
                dataBilling = _.concat(dataBilling,data4)
                // const dataBilling = _.concat(data1,data3,data4)
                if(cmpOpt.wallet_multiple == undefined || cmpOpt.wallet_multiple == false){
                    if(cmpOpt.billing_currency && billing_summary[cmpOpt.billing_currency] == undefined){
                        billing_summary[cmpOpt.billing_currency] = []
                    }
                    if(billing_summary[cmpOpt.billing_currency]['subscription'] == undefined){
                        billing_summary[cmpOpt.billing_currency]['subscription'] = 0
                    }
                    billing_summary[cmpOpt.billing_currency]['subscription'] = subscription

                    if(billing_summary[cmpOpt.billing_currency]['reward_charges'] == undefined){
                        billing_summary[cmpOpt.billing_currency]['reward_charges'] = 0
                    }
                    billing_summary[cmpOpt.billing_currency]['reward_charges'] = reward_charges

                    if(billing_summary[cmpOpt.billing_currency]['reward_credit_balance'] == undefined){
                        billing_summary[cmpOpt.billing_currency]['reward_credit_balance'] = 0
                    }
                    billing_summary[cmpOpt.billing_currency]['reward_credit_balance'] = reward_credit_balance
                }
                let convertedArray:any = [];
                for(let currency in billing_summary){
                    billing_summary[currency].currency = currency
                    convertedArray.push(billing_summary[currency]);
                }
                commit('setHtmlExport', html)
                commit('setBillingSummary', convertedArray)
                commit('setSubscription', subscription)
                commit('setRewardCharge', reward_charges)
                commit('setCreditBalance', reward_credit_balance)
                // commit('setRewardPending', reward_pending)
                commit('setBillingData', _.orderBy(dataBilling,['sortdate'], ['desc']))
                // commit('setBillingData', _.sortBy(dataBilling, [function(o:any) { return o.sortdate; }]))
                commit('setActiveMember', data2)
                commit('setCountryMember', countryMember)
                commit('setLoading', false)
            });
        },
        getExportHTML() {
            return `<!DOCTYPE html>
            <html lang="en">
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Happily.ai Billing Summary</title>
                <link href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap" rel="stylesheet">
                <link rel="stylesheet" href="styles.css">
                <style type="text/css">
                    body {
                        font-family: 'Lato', sans-serif;
                        line-height: 1.4;
                        margin: 0;
                        padding: 20px;
                        color: #2A2A2A;
                        font-size: 14px;
                    }
                    
                    .container {
                        max-width: 1200px;
                        margin: 0 auto;
                        background-color: #fff;
                        padding: 20px;
                        border-radius: 10px;
                        box-shadow: 0 0 20px rgba(0,0,0,0.1);
                    }
                    
                    header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 20px;
                    }
                    
                    #logo img {
                        max-height: 60px;
                    }
                    
                    h1 {
                        font-family: 'Lato', sans-serif;
                        font-weight: 900;
                        font-size: 36px;
                        color: #4C32CC;
                        margin: 0;
                    }
                    
                    h2 {
                        font-family: 'Lato', sans-serif;
                        font-weight: 700;
                        font-size: 24px;
                        color: #4C32CC;
                        margin-top: 0;
                    }
                    
                    .customer-info {
                        margin-bottom: 20px;
                    }
                    
                    .table-container {
                        margin-bottom: 30px;
                    }
                    
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 12px;
                    }
                    
                    th, td {
                        border: 1px solid #ddd;
                        padding: 8px;
                        text-align: left;
                    }
                    
                    th {
                        background-color: #4C32CC;
                        color: white;
                        font-weight: 700;
                    }
                    
                    tr:nth-child(even) {
                        background-color: #f8f8f8;
                    }
                    
                    .summary {
                        background-color: #f0f0f0;
                        padding: 15px;
                        border-radius: 10px;
                        margin-top: 30px;
                    }
                    
                    .footer {
                        margin-top: 30px;
                        text-align: center;
                        color: #666;
                    }
                    
                    .attribution {
                        font-size: 12px;
                    }
                    
                    button {
                        display: block;
                        margin: 20px auto;
                        padding: 10px 20px;
                        background-color: #4C32CC;
                        color: white;
                        border: none;
                        border-radius: 5px;
                        cursor: pointer;
                        font-size: 16px;
                        font-family: 'Lato', sans-serif;
                        font-weight: 700;
                        transition: background-color 0.3s ease;
                    }
                    
                    button:hover {
                        background-color: #3a26a0;
                    }
                </style>
            </head>
            <body>
                <div class="container">
                    <header>
                        <div id="logo">
                            <img src="https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Flogo_blue_52.png?alt=media" alt="Happily.ai Logo">
                        </div>
                        <h1>Billing Summary</h1>
                    </header>
                    
                    <div class="customer-info">
                        <p><strong>Date:</strong> <span id="billing-date">{==DATE==}</span></p>
                        <p><strong>Customer:</strong> <span id="customer-name">{==COMPANY_NAME==}</span></p>
                    </div>
                    
                    <div class="table-container">
                        <h2>Subscription & Services</h2>
                        <table id="subscription-table">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>Qty</th>
                                    <th>Unit Price</th>
                                    <th>Subtotal</th>
                                    <th>Fee</th>
                                    <th>Before Tax</th>
                                    <th>VAT ({==COMPANY_VAT==}%)</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Rows will be added dynamically -->
                                {==SUBSCRIPTION_SERVICES==}
                            </tbody>
                        </table>
                    </div>

                    {==REWARDS_TABLE==}
                    
                    <div class="footer">
                        <p class="attribution">For any questions regarding this billing document, please contact <a href="mailto:billing@happily.ai">billing@happily.ai</a></p>
                        <p class="attribution">Thank you for using Happily.ai!</p>
                    </div>
                </div>
                <button id="generate-pdf">Generate PDF</button>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"></script>
                <script>
                    document.getElementById("generate-pdf").addEventListener("click", function() {
                        const { jsPDF } = window.jspdf;
                        const doc = new jsPDF();
                        
                        html2canvas(document.querySelector(".container")).then(canvas => {
                            const imgData = canvas.toDataURL("image/png");
                            const imgProps = doc.getImageProperties(imgData);
                            const pdfWidth = doc.internal.pageSize.getWidth();
                            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                            
                            doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                            doc.save("happily_ai_billing_summary.pdf");
                        });
                    });
                </script>
            </body>
            </html>`;
        },
        getRewardsHTML({commit,dispatch,state}:any, obj:any){
            let billing_summary = obj.billing_summary
            let billing_rewards = obj.billing_rewards
            let CompanyVat = obj.CompanyVat
            let allSymbol = obj.allSymbol
            let html = '';
            let htmlSummary = '';
            if(Object.keys(billing_rewards).length > 0){
                html += `<div class="table-container">
                        <h2>Rewards</h2>`;
                for(let currency in billing_rewards){
                    let SummarySubtotal = 0
                    let SummaryTotalFee = 0
                    let SummarySubtotalBeforeTax = 0
                    let SummaryTotalVat = 0
                    let SummaryGrandTotal = 0
                    let symbol = allSymbol[currency]
                    if(billing_rewards[currency]['transacted']){
                        html += `<h3>Transacted Rewards</h3>
                                <table id="transacted-rewards-table" class="billing-table">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>Qty</th>
                                            <th>Unit Price</th>
                                            <th>Subtotal</th>
                                            <th>Fee</th>
                                            <th>Before Tax</th>
                                            <th>VAT (${CompanyVat}%)</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Rows will be added dynamically -->
                                `;
                        let arrData:any = []
                        for (let keyRewards in billing_rewards[currency]['transacted']){
                            arrData.push(billing_rewards[currency]['transacted'][keyRewards])
                        }
                        arrData = _.sortBy(arrData, [function(o) { return o.name; }]);
                        _.forEach(arrData, (item:any) => {
                            let unitPrice = item.firstprice
                            let subTotal = item.qty * unitPrice
                            SummarySubtotal += subTotal
                            let fee = item.qty * item.firstfee
                            SummaryTotalFee += fee
                            let beforeTax = subTotal + fee
                            SummarySubtotalBeforeTax += beforeTax
                            let vat = item.qty * item.firsttax
                            SummaryTotalVat += vat
                            SummaryGrandTotal += (item.amout > 0) ? item.amout : 0
                            html += `<tr>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td>${symbol}${unitPrice > 0 ? `${globalfunc.addCommasInNumber(unitPrice,2)}` : '0.00'}</td>
                                <td>${symbol}${globalfunc.addCommasInNumber(subTotal,2)}</td>
                                <td>${item.firstfee > 0 ? `${symbol}${globalfunc.addCommasInNumber(fee,2)}` : ''}</td>
                                <td>${symbol}${globalfunc.addCommasInNumber(beforeTax,2)}</td>
                                <td>${item.firsttax > 0 ? `${symbol}${globalfunc.addCommasInNumber(vat,2)}` : ''}</td>
                                <td>${symbol}${item.amout > 0 ? `${globalfunc.addCommasInNumber(item.amout,2)}` : '0.00'}</td>
                            </tr>`
                        });
                        html += `</tbody>
                            </table>`;
                    }
                    if(billing_rewards[currency]['pending']){
                        html += `<h3>Pending Rewards</h3>
                                <table id="pending-rewards-table" class="billing-table">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>Qty</th>
                                            <th>Unit Price</th>
                                            <th>Subtotal</th>
                                            <th>Fee</th>
                                            <th>Before Tax</th>
                                            <th>VAT (${CompanyVat}%)</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Rows will be added dynamically -->
                                `;
                        let arrData:any = []
                        for (let keyRewards in billing_rewards[currency]['pending']){
                            arrData.push(billing_rewards[currency]['pending'][keyRewards])
                        }
                        arrData = _.sortBy(arrData, [function(o) { return o.name; }]);
                        _.forEach(arrData, (item:any) => {
                            let unitPrice = item.firstprice
                            let subTotal = item.qty * unitPrice
                            SummarySubtotal += subTotal
                            // let fee = item.qty * item.firstfee
                            let fee = 0 // for pending excluding fee
                            SummaryTotalFee += fee
                            let beforeTax = subTotal + fee
                            SummarySubtotalBeforeTax += beforeTax
                            // let vat = item.qty * item.firsttax
                            let vat = 0 // for pending excluding vat
                            SummaryTotalVat += vat
                            // SummaryGrandTotal += (item.amout > 0) ? item.amout : 0
                            SummaryGrandTotal += (subTotal > 0) ? subTotal : 0 // for pending excluding fee + vat
                            // html += `<tr>
                            //     <td>${item.name}</td>
                            //     <td>${item.qty}</td>
                            //     <td>${symbol}${unitPrice > 0 ? `${globalfunc.addCommasInNumber(unitPrice,2)}` : '0.00'}</td>
                            //     <td>${symbol}${globalfunc.addCommasInNumber(subTotal,2)}</td>
                            //     <td>${item.firstfee > 0 ? `${symbol}${globalfunc.addCommasInNumber(fee,2)}` : ''}</td>
                            //     <td>${symbol}${globalfunc.addCommasInNumber(beforeTax,2)}</td>
                            //     <td>${item.firsttax > 0 ? `${symbol}${globalfunc.addCommasInNumber(vat,2)}` : ''}</td>
                            //     <td>${symbol}${item.amout > 0 ? `${globalfunc.addCommasInNumber(item.amout,2)}` : '0.00'}</td>
                            // </tr>`
                            html += `<tr>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td>${symbol}${unitPrice > 0 ? `${globalfunc.addCommasInNumber(unitPrice,2)}` : '0.00'}</td>
                                <td>${symbol}${globalfunc.addCommasInNumber(subTotal,2)}</td>
                                <td>${''}</td>
                                <td>${symbol}${globalfunc.addCommasInNumber(beforeTax,2)}</td>
                                <td>${''}</td>
                                <td>${symbol}${subTotal > 0 ? `${globalfunc.addCommasInNumber(subTotal,2)}` : '0.00'}</td>
                            </tr>`
                        });
                        html += `</tbody>
                            </table>`;
                    }
                    if(Object.keys(billing_summary).length > 0){
                        if(billing_summary[currency] && billing_summary[currency]['subscription'] && billing_summary[currency]['subscription'] > 0){
                            let subscription = billing_summary[currency]['subscription']
                            SummarySubtotal += subscription
                            SummarySubtotalBeforeTax += subscription
                            let SubVat = (subscription * CompanyVat) / 100
                            SummaryTotalVat += SubVat
                            let summary = subscription + SubVat
                            SummaryGrandTotal += summary
                        }
                    }
                    if(htmlSummary !== ''){
                        htmlSummary += `<br>`
                    }
                    htmlSummary += `<p><strong>Subtotal:</strong> <span id="total-subtotal">${symbol}${globalfunc.addCommasInNumber(SummarySubtotal,2)}</span></p>
                                    <p><strong>Total Processing Fees:</strong> <span id="total-processing-fees">${symbol}${globalfunc.addCommasInNumber(SummaryTotalFee,2)}</span></p>
                                    <p><strong>Subtotal before tax:</strong> <span id="total-before-tax">${symbol}${globalfunc.addCommasInNumber(SummarySubtotalBeforeTax,2)}</span></p>
                                    <p><strong>Total VAT:</strong> <span id="total-vat">${symbol}${globalfunc.addCommasInNumber(SummaryTotalVat,2)}</span></p>
                                    <p><strong>Grand Total:</strong> <span id="grand-total">${symbol}${globalfunc.addCommasInNumber(SummaryGrandTotal,2)}</span></p>`
                }
                html += `</div>`

                html += `<div class="summary">
                            <h2>Summary</h2>
                            ${htmlSummary}
                        </div>`
            }
            return html
        }
    },
    getters: {
        billingData : (state:any) => {
            return state.billingData
        },
        activeMember : (state:any) => {
            return state.activeMember
        },
        subscription : (state:any) => {
            return state.subscription
        },
        reward_charges : (state:any) => {
            return state.reward_charges
        },
        reward_credit_balance : (state:any) => {
            return state.reward_credit_balance
        },
        reward_pending : (state:any) => {
            return state.reward_pending
        },
        MonthOfYearOpt : (state:any) => {
            return state.MonthOfYearOpt
        },
        selectMonthOfYear : (state:any) => {
            return state.selectMonthOfYear
        },
        loadingDatableTable : (state:any) => {
            return state.loadingDatableTable
        },
        companySymbol : (state:any) => {
            return state.companySymbol
        },
        countryInCompany:(state:any)=>{
            return state.countryInCompany
        },
        countryMember:(state:any)=>{
            return state.countryMember
        },
        allSymbol : (state:any) => {
            return state.allSymbol
        },
        topupCredit : (state:any) => {
            return state.topupCredit
        },
        billingSummary : (state:any) => {
            return state.billingSummary
        },
        billingPending : (state:any) => {
            return state.billingPending
        },
        htmlExport : (state:any) => {
            return state.htmlExport
        },
    }
  }